app.component("aiCallsListView", {
    templateUrl: "app/src/js/components/aiCalls/aiCallsList.html",
    controller: "aiCallsListController",
    bindings: {
        patientId: "<",
        navigatePrompt: "&"
    }
});

app.controller("aiCallsListController", [
    "$scope", "$mdDialog", "$modal", "ElevenLabsAPI",
    function ($scope, $mdDialog, $modal, ElevenLabsAPI) {
        const ctrl = this;
        $scope.API = ElevenLabsAPI;
        $scope.availableCalls = [];
        $scope.showEdit = false;
        $scope.selectedCall = null;

        ctrl.$onInit = function () {
            ctrl.fetchCalls();
        };

        ctrl.fetchCalls = function () {
            $scope.API.isProcessing = true;
            $scope.API.getOutboundCallsByPatientId(ctrl.patientId)
                .then(resp => { $scope.availableCalls = resp.data; })
                .catch(() => showError())
                .finally(() => { $scope.API.isProcessing = false; });
        };

        function showError() {
            $scope.serverErrorModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                show: true,
                title: "CatTrax has encountered an error",
            });
        }

        $scope.onCreate = function () {
            $scope.selectedCall = null;
            $scope.showEdit = true;
        };

        $scope.onEdit = function (call) {
            $scope.selectedCall = angular.copy(call);
            $scope.showEdit = true;
        };

        $scope.goBackToList = function () {
            $scope.showEdit = false;
            $scope.selectedCall = null;
        };

        $scope.onActionComplete = function () {
            $scope.showEdit = false;
            ctrl.fetchCalls();
        };

        $scope.utcToLocal = (date) => moment.utc(date).local().format("DD/MM/YYYY h:mm A");

        $scope.openDeleteModal = (item) => {
            $scope.onGeneralClick = () => {
                $scope.generalModal.hide();
                $scope.API.deleteOutboundCall(item.outbound_call_id).then(() => ctrl.fetchCalls(), () => showError());
            };
            $scope.generalModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.general.tpl.html",
                show: true,
                title: "Delete AI Call",
                content: "Are you sure you want to delete this AI Call?"
            });
        };

        $scope.closeModal = () => {
            $mdDialog.hide();
        };
    }
]);